import { motion } from "framer-motion";
import { Users, CheckCircle2 } from "lucide-react";
import { Editable } from "@/components/builder/Editable";

const POINTS = [
  { key: "p1", text: "Nasce dai problemi reali di chi gestisce i condomini ogni giorno" },
  { key: "p2", text: "Flussi e linguaggio pensati per lo studio di amministrazione" },
  { key: "p3", text: "Evolve ascoltando gli amministratori che lo usano" },
];

export const MadeByAdmins = () => {
  return (
    <section data-testid="made-by-admins" className="section-lavender">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.4 }} className="card-soft flex flex-col items-start gap-6 p-6 sm:p-9 md:flex-row md:items-center">
          <span className="inline-flex h-16 w-16 flex-none items-center justify-center rounded-2xl bg-primary/10 text-primary"><Users className="h-8 w-8" strokeWidth={2} /></span>
          <div className="flex-1">
            <Editable as="p" path="admins.eyebrow" className="block text-xs font-bold uppercase tracking-[0.16em] text-primary">Da amministratori, per amministratori</Editable>
            <Editable as="h2" path="admins.title" className="mt-1 block font-display text-2xl font-extrabold text-foreground sm:text-3xl">Sedio e sviluppato da amministratori di condominio.</Editable>
            <Editable as="p" path="admins.desc" className="mt-2 block max-w-2xl text-sm leading-6 text-muted-foreground md:text-base">Non un software generico adattato al condominio, ma uno strumento nato da chi vive ogni giorno posta, PEC, segnalazioni e rapporti con fornitori e condomini.</Editable>
            <ul className="mt-5 grid gap-3 sm:grid-cols-3">
              {POINTS.map((p) => (
                <li key={p.key} className="flex items-start gap-2 text-sm text-foreground">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 flex-none text-primary" />
                  <Editable path={`admins.${p.key}`}>{p.text}</Editable>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
